import { ChatEventType } from 'constants/chat-event-type';

export function getChatEventType(inputType: string): ChatEventType {
  if (inputType === ChatEventType.Event || inputType === ChatEventType.SystemMessage) {
    return ChatEventType.Event;
  }

  return inputType as ChatEventType;
}
